// extracted by mini-css-extract-plugin
export var animationContainer = "_p0-0";
export var footer = "_p0-1";
export var gray = "_p0-2";
export var lineItem = "_p0-3";
export var lineItemImage = "_p0-4";
export var lineItemInfo = "_p0-5";
export var lineItemText = "_p0-6";
export var lineItems = "_p0-7";
export var modalContent = "_p0-8";
export var options = "_p0-9";
export var orderName = "_p0-a";
export var refundAmount = "_p0-b";